import React from "react";
import Header from "../modules/pageHeader/index";
import { APP_FOOTER } from "../constants/app.constants";

export const Layout: React.FC<{
  children: React.ReactElement;
  title?: string;
  subtitle?: string;
}> = ({ children, title }) => {
  return (
    <div className="app-master">
      {/* <Navigation title={title} /> */}
      <div className="app-content">
        {/* <PageHeader /> */}
        <Header 
        customer={localStorage?.getItem("Name") ?? ""} 
        contact={localStorage?.getItem("Contact Name FL") ?? ""} 
        />
        {/* Call PageHeader Module <PageHeader  /> */}
        <div className="page-content">{children}</div>
        <div
          className="app-footer"
        >
        {APP_FOOTER}
        </div>
      </div>
    </div>
  );
};
